export interface DbBusinessMember {
  id: string;
  role: DbBusinessMemberRole;
}

export enum DbBusinessMemberRole {
  Owner = "owner",
  Admin = "admin",
  Staff = "staff",
}

export interface InviteMemberData {
  name: string;
  phone: string;
  email: string;
  role: DbBusinessMemberRole;
}
